import React, { Component, PropTypes } from 'react';
import { get } from 'lodash';
import Status from './StatusComponent';
import { SojernTracking } from '../../../../constants/ManageApps';
import { isActive } from './utils';
import If from '../../../helpers/if';
import StatusMessage from './StatusMessageComponent';

class SojernTrackingSection extends Component {
    render() {
        const status = get(this.props.configurationObject, 'status');
        const chainStatus = get(this.props.chainConfigurationObject, 'status');

        return (
            <section className="content-section">
                <Status
                    objectName="sojernTracking"
                    value={status}
                    level={this.props.level}
                    parentValue={chainStatus}
                    setValue={(key, value) => {
                        this.props.setValue(key, value);
                    }}
                />
                <StatusMessage appName={SojernTracking.appName} value={status} parentValue={chainStatus} />
                <If condition={isActive(this.props.level, status, chainStatus)}>
                    <div className="section-content col-md-12">
                        <p className="spark-message__content">
                            Once your Sojern account is activated, enabling this setting will set Sojern
                            <br />
                            tracking for "Product Availability Success (Search)", "Checkout (Shopping
                            <br />
                            Card)" and "Confirm Reservation Success (Conversion)" for{' '}
                            <span className="spark-bold">all configurations</span>.
                        </p>
                    </div>
                </If>
            </section>
        );
    }
}

SojernTrackingSection.propTypes = {
    configurationObject: PropTypes.obj,
    chainConfigurationObject: PropTypes.obj,
    level: PropTypes.string,
    setValue: PropTypes.func
};

export default SojernTrackingSection;



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/SojernTrackingSection.js